import React, { useState, useEffect } from 'react';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppMeterGroupsService from '../../AppMeterGroupsService';

//global component
import ModalButton from '../../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
  InputStyles,
  SelectStyles,
} from '../../../../SharedStyles';

const EditModal = (props) => {
  const { handleCloseModal, handleDataChange } = props;
  const { strings } = AppMeterGroupsService;
  const [meterGroup, setMeterGroup] = useState({});
  const [locationList, setLocationsList] = useState([]);
  useEffect(() => {
    setMeterGroup(props.meterGroup);
    setLocationsList(props.account.locations);
  }, [props.meterGroup, props.account]);

  const closeModal = () => {
    handleCloseModal();
  };

  const handleChange = (e) => {
    setMeterGroup({ ...meterGroup, [e.target.name]: e.target.value });
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    let updatedLocationMeterGroup = meterGroup;
    let locationData = locationList.filter((loc) => {
      return loc.id === meterGroup.locationId;
    });
    updatedLocationMeterGroup.locationName = locationData[0].name;

    handleDataChange('meterGroup', updatedLocationMeterGroup);
    handleCloseModal();
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.meterGroupName}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0 10px'>
            <p>{strings.editContent}</p>
          </ModalItemStyles>
          {/* Section */}
          <form id='modalForm' onSubmit={handleSaveInfo}>
            <ModalItemStyles>
              <InputStyles
                type='text'
                onChange={handleChange}
                name='name'
                placeholder={strings.editNamePlaceholder}
                value={meterGroup.name || ''}
                required
              />
              <InputStyles
                type='text'
                onChange={handleChange}
                name='lotId'
                placeholder={strings.editLotIdPlaceholder}
                value={meterGroup.lotId || ''}
                required
              />
              <SelectStyles
                name='locationId'
                required
                onChange={handleChange}
                value={meterGroup.locationId || ''}>
                <option value='' disabled>
                  select location...
                </option>
                {locationList &&
                  locationList.map((loc) => {
                    return (
                      <option key={loc.id} value={loc.id}>
                        {loc.name}
                      </option>
                    );
                  })}
              </SelectStyles>
            </ModalItemStyles>
          </form>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          formSubmit='modalForm'
          buttonText={strings.ok}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default EditModal;
